import './scrollTrigger';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import bp from '../../../apps/json/breakpoints.json';

const baseClass = 'QuoteBackgroundImage';
const selectors = {
	base: `.${baseClass}`,
	quote: `.${baseClass}-quote`,
};

const init = $container => {
	const $quote = $container.find(selectors.quote);

	ScrollTrigger.matchMedia({
		[`(max-width: ${Number.parseInt(bp.breakpoints.md.replace('px', '')) - 1}px)`]: () => {
			gsap.to($quote, {
				scrollTrigger: {
					trigger: $container,
					start: `top+=200 bottom`,
				},
				opacity: 1,
				translateY: 0,
				duration: 1,
			});
		},
		[`(min-width: ${bp.breakpoints.md}) and (max-width: ${
			Number.parseInt(bp.breakpoints.lg.replace('px', '')) - 1
		}px)`]: () => {
			gsap.to($quote, {
				scrollTrigger: {
					trigger: $container,
					start: `top+=250 bottom`,
				},
				opacity: 1,
				translateY: 0,
				duration: 1,
			});
		},
		[`(min-width: ${bp.breakpoints.lg})`]: () => {
			gsap.to($quote, {
				scrollTrigger: {
					trigger: $container,
					start: `top+=300 bottom`,
				},
				opacity: 1,
				translateY: 0,
				duration: 1,
			});
		},
	});
};

export default function initQuoteBackgroundImage() {
	$(selectors.base).each((i, quote) => {
		init($(quote));
	});
}
